import React from "react";
import "./checkInput.css";
import { ReactComponent as CheckImg } from "./checked.svg";

const CheckInput = ({
  heading,
  value,
  conditions,
  handleNavigation,
  paramFilters,
}) => {
  let _value = value;

  const valueFromUrl = paramFilters[_value] || [];

  function handleCheck(e, item) {
    const checked = e.target.checked;

    handleNavigation({
      [value]: {
        item,
        checked,
      },
    });
  }

  return (
    <section className="checkInput">
      <h5>{heading}</h5>
      {conditions?.map((item) => {
        const single_item_vlue = item.value;
        const name = item.name;

        return (
          <div className="chekInput__wrapper" key={single_item_vlue}>
            <input
              id={heading + name}
              type="checkbox"
              checked={
                valueFromUrl === single_item_vlue ||
                valueFromUrl?.includes(single_item_vlue)
              }
              onChange={(e) => handleCheck(e, single_item_vlue)}
            />
            <CheckImg />
            <label htmlFor={heading + name}>{name}</label>
          </div>
        );
      })}
    </section>
  );
};

export default CheckInput;
